module.exports = __webpack_public_path__ + "static/media/listing-page-coorg.5a569866.jpg";